import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconEvents = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.3333 7.99984H8V11.3332H11.3333V7.99984ZM10.6667 0.666504V1.99984H5.33333V0.666504H4V1.99984H3.33333C2.59333 1.99984 2.00667 2.59984 2.00667 3.33317L2 12.6665C2 13.3998 2.59333 13.9998 3.33333 13.9998H12.6667C13.4 13.9998 14 13.3998 14 12.6665V3.33317C14 2.59984 13.4 1.99984 12.6667 1.99984H12V0.666504H10.6667ZM12.6667 12.6665H3.33333V5.33317H12.6667V12.6665Z",
		fill: "#959595"
	})
});
export default SvgIconEvents;
